import { AttributePlainEnumValue } from '@commercetools/platform-sdk';

const PPA_BAG_SIZES = [
  'NSSB',
  'NSS',
  'NSM',
  'NSLB',
  'CSSB',
  'CSS',
  'CSL',
  'SNS',
  'SNL',
  'SNLB',
  'DFSB',
  'DFS',
  'DFL',
  'DFLB',
];

/**
 * Check if a bag size is a PPA bag size.
 *
 * The list with PPA bag sizes is defined in {@link PPA_BAG_SIZES}.
 *
 * @param bagSize The bag size to check, as a {@link AttributePlainEnumValue}.
 */
export const isPpaBagSize = (bagSize?: AttributePlainEnumValue) =>
  bagSize ? PPA_BAG_SIZES.includes(bagSize.key) : false;
